export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/fission/ice-box' */ './IceBox'
  );
